import React, {useState,useEffect} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import arrowAnim from "../animation/ArrowDownBounce.json"

import "../styles/Career.css";
import Footer from '../component/footer';

const cdnURL = process.env.REACT_APP_CDN_URL;

const drives = [
  { id: 1, logo: `${cdnURL}/images/career/icon_human touch_selected.svg`, title: "HUMAN TOUCH", description: "It is the core of everything we do, every effort begins and ends with people."},
  { id: 2, logo: `${cdnURL}/images/career/icon_innovation_selected.svg` , title: "DRIVING IMPACT THROUGH INNOVATION", description: "We believe in building the tech we use, because true innovation starts from within."},
  { id: 3, logo: `${cdnURL}/images/career/icon_technologies_selected.svg`, title: "TECHNOLOGIES", description: "That we need to own and control primary technologies behind the products we make."}
];

const core = [
    { image:`${cdnURL}/images/career/icon_customer.svg`, title:"CUSTOMER FIRST", description:"Solve real needs, always."},
    { image:`${cdnURL}/images/career/icon_innovative.svg`, title:"INNOVATE CONTINUOUSLY", description:"Adapt, refine, evolve."},
    { image:`${cdnURL}/images/career/icon_build.svg`, title:"OWN WHAT YOU BUILD", description:"Strive for excellence."},
    { image:`${cdnURL}/images/career/icon_deliver.svg`, title:"DELIVER RELIABILITY", description:"Trust through consistency."},
    { image:`${cdnURL}/images/career/icon_positivity.svg`, title:"GENERATE POSITIVITY", description:"Impact every interaction."},
    { image:`${cdnURL}/images/career/icon_resources.svg`, title:"STEWARD RESOURCES", description:"Evolve with balance."}
]

const fun = [
    { image:`${cdnURL}/images/career/icon_environment.svg`, title:"environment", description:"A fast-paced environment that challenges and inspires"},
    { image:`${cdnURL}/images/career/icon_skillset.svg`, title:"skill", description:"Real opportunities to expand your skill set"},
    { image:`${cdnURL}/images/career/icon_careerpath.svg`, title:"careerpath", description:"A rewarding career path,</br> not just a job"},
    { image:`${cdnURL}/images/career/icon_growth.svg`, title:"growth", description:"Hands-on experience that accelerates your growth"},
    { image:`${cdnURL}/images/career/icon_dynamicteam.svg`, title:"dynamicteam", description:"A dynamic, driven team that supports each other"},

]

const xoxfamily = [
    { name:"ENG LAY TIN", position:"Senior Manager, Channel Marketing", description:"XOX has a forward-thinking leadership that promotes cross-functional collaboration, which makes my work here highly rewarding, and enabling an accelerated growth for my career."},
    { name:"SUBASHINI A/P SELVANAYAGAM", position:"AGM, Retail", description:"I appreciate the dynamism here in XOX, as I have the chance to learn a variety of subjects. It strengthens my resolve, character, and approach towards life."},
    { name:"LOW TZE KWONG", position:"System Admin Manager", description:"A positive feedback loop to maintain the integrity and efficiency of my work. Plenty of cross-departmental opportunities to collaborate on, every project is an exciting challenge."},
    { name:"NOR HIDAYU MOHD MUALIP", position:"Manager, Regulatory & Government Affairs", description:"XOX is a great place for me to build my career in the tech industry. The support structure is amazing, and the work is constantly fresh with new challenges."},
    { name:"Ahmad Khairul Isam", position:"Senior Manager, Network & Infrastructure", description:"I enjoy the multi-cultural workforce here where I am constantly learning new ways to approach a familiar challenge."},
]
const Career = () => {

    const [activeIndex, setActiveIndex] = useState(1);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const nextSlide = () => {
        setActiveIndex((prev) => (prev + 1) % drives.length);
    };

    const prevSlide = () => {
        setActiveIndex((prev) => (prev - 1 + drives.length) % drives.length);
    };

    const getClass = (index) => {
        if (index === activeIndex) return "center";
        if (index === (activeIndex - 1 + drives.length) % drives.length)
        return "left";
        if (index === (activeIndex + 1) % drives.length) return "right";
        return "hidden"; // hide others if >3 drives
    };

    function getDriveSlider () {

        return (
            <div className="drives-slider-container" >
                <div className="drives-slider">
                    <button onClick={prevSlide} className="nav-btn">
                        <Lottie animationData={arrowAnim} loop={true} style={{transform: "rotate(90deg)" }} className="arrow-drives"/>
                    </button>

                    <div className="drives">
                    {drives.map((b, i) => (
                        <div key={b.id} className={getClass(i) + " drive-item"}>
                        <div className="drives-core">
                            <img src={b.logo}/>
                        </div>
                        
                        {i === activeIndex && (
                            <div className="drives-details">
                            <h1>{b.title}</h1>
                            <p>{b.description}</p>
                            {/* <a href={b.link} className="learn-more btn btn-discover"><span>Learn More</span></a> */}
                            </div>
                        )}
                        </div>
                    ))}
                    </div>

                    <button onClick={nextSlide} className="nav-btn">
                        <Lottie animationData={arrowAnim} loop={true} style={{transform: "rotate(-90deg)" }} className="arrow-drives"/>
                    </button>
                </div>

                <div className="drives-pagination">
                    {drives.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === activeIndex ? "active" : ""}`}
                        onClick={() => setActiveIndex(index)}
                    ></span>
                    ))}
                </div>
            </div>
        )
    }

    const sliderXOXfamily = {
        infinite: true,
        slidesToShow: 3,
        centerMode: false,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 12000,
        cssEase: "linear",
    };

    const sliderXOXfamilysmall = {
        infinite: true,
        slidesToShow: 1.5,
        centerMode: false,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 12000,
        cssEase: "linear",
    };

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="career-page">

            <div className="top_banner">

                <video autoPlay muted loop playsInline className="banner-video" >
                    <source src={`${cdnURL}/video/career.mp4`} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <div className="banner_text">
                    {/* <h1>CAREERS AT XOX</h1> */}
                    <h2>Powering Possibilities.</h2>
                    <h2>Building the Future Together.</h2>
                    <p>Your next big opportunity starts here.</p>

                    <div className="cbanner-btn">
                        <a className="btn btn-roles" href="/careerlist" style={{ "--arrow-icon": `url(${cdnURL}/icon/icon_white_arrow_a.svg)` }}> <span>See Open Roles</span></a>
                    </div>

                    <div className="drives-text">
                        <h1>WHAT DRIVES US</h1>
                        <p>Our work goes beyond connectivity. We are building{screenWidth > 600 ? <br/> : null} a digital future, one that empowers people, supports businesses,{screenWidth > 600 ? <br/> : null} and strengthens communities across the nation.</p>
                        <p>As a proudly homegrown brand, we believe in:</p>
                    </div>

                </div>
                
                {screenWidth > 900 ? getDriveSlider(): null}
                    
                <img src={`${cdnURL}/images/career/banner_careers.png`}/>

            </div>

            {screenWidth <= 900 ? (
                <div className="mobile-slider-wrapper">
                    {getDriveSlider()}
                </div>
            ) : null
            }

            <div className="yellow-part" style={{backgroundImage: `url("${cdnURL}/images/career/bg_corevalues.png"})`}}>
       
                <div className="core_value">
                    <div className="core_title">
                        <h1>OUR CORE VALUES</h1>
                    </div>
                    
                    <div className="core_grid">
                        {core.map((d, i) => (
                        <div key={i} className="core-card" >
                            <img src={d.image} alt={d.title} />
                            <h1 dangerouslySetInnerHTML={{ __html: d.title }} />
                            <h4 dangerouslySetInnerHTML={{ __html: d.description }} />
                        </div>
                        ))}
                    </div>
                </div>

                <div className="container-fun">   
                    <div className="fun-text">
                        <h1> HERE'S <br/>THE <span>FUN</span> PART!</h1> 
                        <p> At XOX, we keep things bold, vibrant, and full of ideas.</p>  
                        <p>Age? Just a number. What matters is your energy, your mindset, and{screenWidth > 600 ? <br/> : null} how well you connect and collaborate with the team. We celebrate{screenWidth > 600 ? <br/> : null} creativity, value fresh thinking, and believe innovation starts when{screenWidth > 600 ? <br/> : null} you step outside the box. </p>
                    </div>
                    <div className="fun-image">
                        <img src={`${cdnURL}/images/career/fun_part.png`} alt="aboutusBanner" />
                    </div>
                </div>

                <div className="fun-grid">
                    {fun.map((d, i) => (
                    <div key={i} className="fun-card" >
                        <img src={d.image} alt={d.title} />
                        <h4 dangerouslySetInnerHTML={{ __html: d.description }} />
                    </div>
                    ))}
                </div>

            </div>

            <div className="perk-part">
                <div className="perk_title">
                    <h1>THE PERKS</h1>
                    <p>We’ve created a culture where great perks meet great people — because you deserve both.</p>
                </div>

                <div className="perk-grid">
                    <div className="perk-card">
                        <h1>01</h1>
                        <h2>COMPETITIVE SALARY & <br/>WORK BENEFITS PACKAGE</h2>
                    </div>
                    <div className="perk-card">
                        <h1>02</h1>
                        <h2>5 DAYS WORK WEEK & <br/>FLEXIBLE WORK HOURS</h2>
                    </div>
                    <div className="perk-card">
                        <h1>03</h1>
                        <h2>SMART CASUAL <br/>ATTIRE</h2>
                    </div>
                </div>

            </div>
            
            {/* <div className="xoxfamily" style={{backgroundImage: `url("${cdnURL}/images/career/bg_xoxfamily.png"})`}}> */}
            <div className="xoxfamily">

                <video autoPlay muted loop playsInline className="xoxfamily-video" > 
                    <source src={`${cdnURL}/video/xoxcareer_family.mp4`} type="video/mp4" /> Your browser does not support the video tag.
                </video>

                <div className="xoxfamily_title">
                    <h1>FROM <br/>OUR FAMILY</h1>
                    <p>Hear directly from our team about their experience</p>
                </div>

                <div className="xoxfamily-grid">
                    <Slider {...(screenWidth > 1000 ? sliderXOXfamily : sliderXOXfamilysmall)}>
                        {xoxfamily.map((d, i) => (
                        <div key={i} className="xoxfamily-card" >
                            <h1 dangerouslySetInnerHTML={{ __html: d.name }} />
                            <h2 dangerouslySetInnerHTML={{ __html: d.position }} />
                            <span> “ </span>
                            <h4 dangerouslySetInnerHTML={{ __html: d.description }} />
                        </div>
                        ))}
                    </Slider>
                </div>
            </div>

            <div className="build_career" style={{backgroundImage: `url("${cdnURL}/images/career/bg_careers.png"})`}}>
                <div className="build_career-title">
                    <h1>READY TO <br/>BUILD YOUR CAREER?</h1>
                    <p>Whether you're just starting out or ready to lead — there's a place for you here.</p>
                </div>

                <div className="build_career-grid">
                    <div className="build_career-card" >
                        <a href="/careerlist">
                            <img src={`${cdnURL}/images/career/leadership.png`} alt="leadership" className="normal-img"/>
                            <img src={`${cdnURL}/images/career/leadership_hover.png`} alt="leadershiphover" className="hover-img"/>
                        </a>
                    </div>
                    <div className="build_career-card" >
                        <a href="/careerlist">
                            <img src={`${cdnURL}/images/career/join_professional_team.png`} alt="joinprofessionalteam" className="normal-img"/>
                            <img src={`${cdnURL}/images/career/join_professional_team_hover.png`} alt="joinprofessionalteamhover" className="hover-img"/>
                        </a>
                    </div>
                    <div className="build_career-card" >
                        <a href="/careerlist">
                            <img src={`${cdnURL}/images/career/industrial_training.png`} alt="industrialtraining" className="normal-img"/>
                            <img src={`${cdnURL}/images/career/industrial_training_hover.png`} alt="industrialtraininghover" className="hover-img"/>
                        </a>
                    </div>
                </div>

                <div style={{padding:"5.208vw 0px"}}>
                    <div className="apply-btn">
                        <Link className="btn btn-apply" to="/careerlist" style={{ "--arrow-icon": `url(${cdnURL}/icon/icon_red_arrow.svg)` }}> <span>Apply Now</span></Link>
                    </div>
                </div>
            </div>

            <div style={{padding:"0px 5.208vw"}}>
                <Footer />
            </div>
        </div>
    );
};

export default Career;